import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import * as Constantes from '../shared/constants';

@Pipe({
  name: 'uicLabelEstado'
})
export class UicLabelEstadoPipe implements PipeTransform {

  constructor(private sanitizer: DomSanitizer) { }

  transform(value: unknown): SafeHtml {
    let label = '';
    let cssClass = '';
    let icon = '';
    let strong = false;

    switch (value) {
      case Constantes.ESTADO_UIC_DISPONIBLE:
        label = 'Disponible';
        cssClass = 'badge-estado-success';
        break;
      case Constantes.ESTADO_UIC_EN_RECOGIDA:
        label = 'En recogida';
        cssClass = 'badge-estado-info';
        break;
      case Constantes.ESTADO_UIC_EN_PREPARACION:
        label = 'En preparación';
        cssClass = 'badge-estado-info';
        break;
      case Constantes.ESTADO_UIC_CADUCADO:
        label = 'Caducado';
        cssClass = 'badge-estado-danger';
        strong = true;
        break;
      case Constantes.ESTADO_UIC_LLENO:
        label = 'Carro lleno';
        cssClass = 'badge-estado-warning';
        break;
      default:
        return this.sanitizer.bypassSecurityTrustHtml(`<span class="badge badge-estado-muted">Desconocido</span>`);
    }

    // Construir HTML final
    const text = strong ? `<strong>${label}</strong>` : label;
    const html = `<span class="badge ${cssClass}">${icon} ${text}</span>`;

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}